const siteLanguageList = [
  {
    code: 'en',
    name: 'English',
    released: true,
  },
  {
    code: 'ar',
    name: 'العربية',
    released: true,
  },
  {
    code: 'ca',
    name: 'Català',
    released: false,
  },
  {
    code: 'es-419',
    name: 'Español (Latinoamérica)',
    released: true,
  },
  {
    code: 'fr',
    name: 'Français',
    released: true,
  },
  {
    code: 'he',
    name: 'עברית',
    released: false,
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    released: false,
  },
  {
    code: 'ko-kr',
    name: '한국어 (대한민국)',
    released: false,
  },
  {
    code: 'pl',
    name: 'Polski',
    released: false,
  },
  {
    code: 'pt-br',
    name: 'Português (Brasil)',
    released: false,
  },
  {
    code: 'ru',
    name: 'Русский',
    released: false,
  },
  {
    code: 'th',
    name: 'ไทย',
    released: false,
  },
  {
    code: 'uk',
    name: 'Українська',
    released: false,
  },
  {
    code: 'zh-cn',
    name: '中文 (简体)',
    released: true,
  },
];

export default siteLanguageList;
